import React from 'react';
import CourseCardV2 from 'Components/CourseCardV2/CourseCardV2';
import FilterContainer from 'Containers/FilterContainer';
import LoadingContainer from 'Containers/LoadingContainer';
import type { AdminCourseI } from 'types';
import type { AdminCourseCardSectionI } from '../../../Hooks/useCoursesPage';
import { CourseSection, ListCourses, SectionTitle } from './CoursesCardGrid.styled';

export interface CoursesCardGridPropsI {
  sections: AdminCourseCardSectionI[];
  loading: boolean;
  emptyText: React.ReactNode;
  onCourseClick: (course: AdminCourseI) => void;
  onCourseEdit: (course: AdminCourseI) => void;
}

export default function CoursesCardGrid({
  sections,
  loading,
  emptyText,
  onCourseClick,
  onCourseEdit,
}: CoursesCardGridPropsI) {
  // El hook no emite secciones vacías: sin secciones no hay nada que
  // encabezar, un solo vacío (o el loading).
  if (sections.length === 0)
    return (
      <FilterContainer>
        <LoadingContainer isLoading={loading}>{emptyText}</LoadingContainer>
      </FilterContainer>
    );

  return (
    <>
      {sections.map(section => (
        <CourseSection key={section.key} data-testid="course-section" data-section={section.key}>
          {/* El título comparte FilterContainer con la rejilla: así hereda su misma
              geometría (ancho y centrado) en vez de replicarla, y su padding-left
              (GRID_INSET, el mismo de ListCourses) lo alinea con las cards. */}
          <FilterContainer>
            <SectionTitle data-testid="course-section-title">{section.title}</SectionTitle>
          </FilterContainer>
          <FilterContainer>
            <ListCourses>
              {section.items.map(item => (
                <CourseCardV2
                  key={item.course.id}
                  name={item.name}
                  thumbnailUrl={item.thumbnailUrl}
                  description={item.description}
                  category={item.category}
                  creator={item.creator}
                  draftLabel={item.draftLabel}
                  onEdit={() => onCourseEdit(item.course)}
                  onClick={() => onCourseClick(item.course)}
                />
              ))}
            </ListCourses>
          </FilterContainer>
        </CourseSection>
      ))}
    </>
  );
}
